webpackJsonp([255617574101689],{

/***/ 438:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---resources-dietary-info-anti-reflux-diet-a0e39f21c11f6a62c5ab.js